import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrCode({ value, size = 70 }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    QRCode.toDataURL((value || "RESICETAK").toString(), {
      margin: 0,
      width: size * 3,
      color: { dark: "#000000", light: "#ffffff" },
      errorCorrectionLevel: "M",
    }).then(setSrc).catch(() => setSrc(""));
  }, [value, size]);
  if (!src) return null;
  return <img src={src} alt="QR" width={size} height={size} data-testid="label-qrcode" style={{ imageRendering: "pixelated" }} />;
}
